import { addFullscreenModal } from '@/redux/reducers/modalsReducer';
import { selectNotUpgradedProductOfDay } from '@/redux/selectors/contractSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/store';

type UseDailyGoodsLinkReturnType = {
  onClick: () => void;
  isVisible: boolean;
  expiredAt?: string;
};

const useDailyGoodsLink = (): UseDailyGoodsLinkReturnType => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector(selectNotUpgradedProductOfDay);
  const showDailyGoodsLink = useAppSelector(
    (state) => state.app.showDailyGoodsLink,
  );

  const handleClick = (): void => {
    if (contract) {
      dispatch(addFullscreenModal({ name: 'productOfDayOffers', props: {} }));
    }
  };

  return {
    onClick: handleClick,
    isVisible: !!contract && showDailyGoodsLink,
    expiredAt: contract?.expiredAt,
  };
};

export { useDailyGoodsLink };
